import { Link } from "react-router-dom";
import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

// KEEP OLD PROJECT IMAGES (UNCHANGED)
import CentralizedCryptoExchange from "../../images/serviceSection/Crypto Exchange Services/Centralized Crypto Exchange.png";
import CryptoListingServices from "../../images/serviceSection/Crypto Exchange Services/Crypto Listing Services.png";
import DecentralizedCryptoExchange from "../../images/serviceSection/Crypto Exchange Services/Decentralized Crypto Exchange.png";
import ExchangeDevelopment from "../../images/serviceSection/Crypto Exchange Services/Exchange Development.png";
import HybridCryptoExchange from "../../images/serviceSection/Crypto Exchange Services/Hybrid Crypto Exchange.png";
import KYCAMLServices from "../../images/serviceSection/Crypto Exchange Services/KYC & AML Services.png";
import P2PCryptoExchange from "../../images/serviceSection/Crypto Exchange Services/P2P Crypto Exchange.png";
import WhitelabelCryptoWallet from "../../images/serviceSection/Crypto Exchange Services/Whitelabel Crypto Wallet.png";
import WhitelabelExchange from "../../images/serviceSection/Crypto Exchange Services/Whitelabel Exchange.png";


// SAME ARROW ICON (UNCHANGED)
const ArrowIcon = () => (
  <>
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
      <rect x="5.23" y="17.32" width="17.88" height="2.27" transform="rotate(-40.28 5.23 17.32)" fill="white" />
      <rect x="7.75" y="6.25" width="2.27" height="2.27" transform="rotate(-40.28 7.75 6.25)" fill="white" />
      <rect x="10.95" y="6.52" width="2.27" height="2.27" transform="rotate(-40.28 10.95 6.52)" fill="white" />
      <rect x="14.16" y="6.78" width="2.27" height="2.27" transform="rotate(-40.28 14.16 6.78)" fill="white" />
      <rect x="17.09" y="10.25" width="2.27" height="2.27" transform="rotate(-40.28 17.09 10.25)" fill="white" />
      <rect x="16.83" y="13.45" width="2.27" height="2.27" transform="rotate(-40.28 16.83 13.45)" fill="white" />
      <rect x="16.56" y="16.65" width="2.27" height="2.27" transform="rotate(-40.28 16.56 16.65)" fill="white" />
    </svg>

    <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
      <rect x="5.23" y="17.32" width="17.88" height="2.27" transform="rotate(-40.28 5.23 17.32)" fill="white" />
      <rect x="7.75" y="6.25" width="2.27" height="2.27" transform="rotate(-40.28 7.75 6.25)" fill="white" />
      <rect x="10.95" y="6.52" width="2.27" height="2.27" transform="rotate(-40.28 10.95 6.52)" fill="white" />
      <rect x="14.16" y="6.78" width="2.27" height="2.27" transform="rotate(-40.28 14.16 6.78)" fill="white" />
      <rect x="17.09" y="10.25" width="2.27" height="2.27" transform="rotate(-40.28 17.09 10.25)" fill="white" />
      <rect x="16.83" y="13.45" width="2.27" height="2.27" transform="rotate(-40.28 16.83 13.45)" fill="white" />
      <rect x="16.56" y="16.65" width="2.27" height="2.27" transform="rotate(-40.28 16.56 16.65)" fill="white" />
    </svg>
  </>
);

// 🔑 MEGAMENU-5 → PAGE DATA
const megaProjects = [
  {
    title: "Exchange Development",
    content:
      "Custom cryptocurrency exchange development with secure trading engines, liquidity integration, and scalable infrastructure.",
    link: "/exchange-development",
    images: [ExchangeDevelopment, ExchangeDevelopment, ExchangeDevelopment, ExchangeDevelopment],
    reverse: false,
  },
  {
    title: "Whitelabel Exchange",
    content:
      "Launch your exchange faster using our white-label crypto exchange solutions with full customization and admin control.",
    link: "/white-label-exchange",
    images: [WhitelabelExchange, WhitelabelExchange, WhitelabelExchange, WhitelabelExchange],
    reverse: true,
  },
  {
    title: "Whitelabel Crypto Wallet",
    content:
      "Secure white-label crypto wallets with multi-chain support, private key management, and enterprise-grade security.",
    link: "/white-label-wallet",
    images: [WhitelabelCryptoWallet, WhitelabelCryptoWallet, WhitelabelCryptoWallet, WhitelabelCryptoWallet],
    reverse: false,
  },
  {
    title: "KYC & AML Services",
    content:
      "Compliant KYC and AML solutions to verify users, prevent fraud, and meet global regulatory requirements.",
    link: "/kyc-aml-services",
    images: [KYCAMLServices, KYCAMLServices, KYCAMLServices, KYCAMLServices],
    reverse: true,
  },
  {
    title: "Hybrid Crypto Exchange",
    content:
      "Hybrid exchanges combining the benefits of centralized speed and decentralized security for advanced trading.",
    link: "/hybrid-crypto-exchange-development",
    images: [HybridCryptoExchange, HybridCryptoExchange, HybridCryptoExchange, HybridCryptoExchange],
    reverse: false,
  },
  {
    title: "P2P Crypto Exchange",
    content:
      "Peer-to-peer crypto exchange platforms enabling direct user trading with escrow, dispute management, and automation.",
    link: "/p2p-crypto-exchange-development",
    images: [P2PCryptoExchange, P2PCryptoExchange, P2PCryptoExchange, P2PCryptoExchange],
    reverse: true,
  },
  {
    title: "Centralized Crypto Exchange",
    content:
      "High-performance centralized exchanges with advanced order books, admin dashboards, and liquidity solutions.",
    link: "/centralized-crypto-exchange-development",
    images: [CentralizedCryptoExchange, CentralizedCryptoExchange, CentralizedCryptoExchange, CentralizedCryptoExchange],
    reverse: false,
  },
  {
    title: "Decentralized Crypto Exchange",
    content:
      "Decentralized exchange platforms with smart contracts, AMM models, and non-custodial trading.",
    link: "/decentralized-crypto-exchange-development",
    images: [DecentralizedCryptoExchange, DecentralizedCryptoExchange, DecentralizedCryptoExchange, DecentralizedCryptoExchange],
    reverse: true,
  },
  {
    title: "Crypto Listing Services",
    content:
      "Token and exchange listing services to increase visibility, liquidity, and market credibility.",
    link: "/crypto-listing-service",
    images: [CryptoListingServices, CryptoListingServices, CryptoListingServices, CryptoListingServices],
    reverse: false,
  },
];

const CryptoExchangeServicesPage: React.FC = () => {
  return (
    <Fragment>
      <div className="service-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle
              pageTitle="Crypto Exchange Services"
              pagesub="CEX, DEX, P2P & Hybrid Solutions"
            />

            <section className="service pos-rel">
              <div className="container mxw-1650">
                <div className="xb-project-wrap xb-project-wrap_2">

                  {megaProjects.map((item, index) => (
                    <div className="xb-project-item" key={index}>

                      {!item.reverse ? (
                        <>
                          <div className="xb-project-content">
                            <div className="xb-item--inner xb-border">
                              <h2 className="xb-item--title">{item.title}</h2>
                              <p className="xb-item--content clr-white">{item.content}</p>

                              <div className="xb-item--btn mt-40">
                                <Link className="thm-btn agency-btn" to={item.link}>
                                  <span className="text">Explore</span>
                                  <span className="arrow">
                                    <span className="arrow-icon"><ArrowIcon /></span>
                                  </span>
                                </Link>
                              </div>
                            </div>
                          </div>

                          <div className="xb-project-img img-hove-effect">
                            <div className="xb-img">
                              {item.images.map((img, i) => (
                                <Link to={item.link} key={i}>
                                  <img src={img} alt="service" />
                                </Link>
                              ))}
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="xb-project-img img-hove-effect">
                            <div className="xb-img">
                              {item.images.map((img, i) => (
                                <Link to={item.link} key={i}>
                                  <img src={img} alt="service" />
                                </Link>
                              ))}
                            </div>
                          </div>

                          <div className="xb-project-content">
                            <div className="xb-item--inner xb-border">
                              <h2 className="xb-item--title">{item.title}</h2>
                              <p className="xb-item--content clr-white">{item.content}</p>

                              <div className="xb-item--btn mt-40">
                                <Link className="thm-btn agency-btn" to={item.link}>
                                  <span className="text">Explore</span>
                                  <span className="arrow">
                                    <span className="arrow-icon"><ArrowIcon /></span>
                                  </span>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                    </div>
                  ))}

                </div>
              </div>
            </section>

          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default CryptoExchangeServicesPage;
